import { axiosGet } from '../logic/axios/wrappers/axios.get.wrapper'
import {
  toContractTypeNamesParam,
  toDepartmentPostalPrefixParam,
} from '../shared/job-listings-filters'
import { getJobListingsUrl } from './config'
import type { ListJobListingsSuccess } from './job-listing.types'

import {
  type InfiniteData,
  type UseInfiniteQueryResult,
  keepPreviousData,
  useInfiniteQuery,
} from '@tanstack/react-query'

export const getInstitutionJobAdsQueryKey = 'get-public-institution-job-ads'

export const useGetPublicInstitutionJobAdsInfiniteQuery = (
  institutionUuid: string,
  department?: string,
  search?: string,
  sortBy?: string,
  sortOrder?: string,
  contractTypes?: string,
  contractDurations?: string,
  requiredExperiences?: string,
  context?: string,
): UseInfiniteQueryResult<InfiniteData<ListJobListingsSuccess>, Error> =>
  useInfiniteQuery({
    queryKey: [
      getInstitutionJobAdsQueryKey,
      institutionUuid,
      department ?? '',
      search ?? '',
      sortBy ?? '',
      sortOrder ?? '',
      contractTypes ?? '',
      contractDurations ?? '',
      requiredExperiences ?? '',
      context ?? '',
    ],
    queryFn: ({ pageParam }) =>
      axiosGet<ListJobListingsSuccess>(getJobListingsUrl(), {
        params: {
          page: pageParam,
          limit: 12,
          institutionUuid,
          department: toDepartmentPostalPrefixParam(department),
          search,
          sortBy,
          sortOrder,
          contractTypes: toContractTypeNamesParam(contractTypes),
          contractDurations,
          requiredExperiences,
          context,
          board: 'career_site',
        },
      }),
    getNextPageParam: (lastPage) => {
      return lastPage.pagination.page < lastPage.pagination.pages
        ? lastPage.pagination.page + 1
        : undefined
    },
    initialPageParam: 1,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    placeholderData: keepPreviousData,
    enabled: !!institutionUuid,
  })
